import { Box, useMediaQuery, useTheme } from '@mui/material';
import MainLayout from 'src/pages/private';
import { useState, FC } from 'react';
import TextField from 'src/components/InputFields/TextField';
import CustomDialog from 'src/components/DialogBox/FormBox/CustomBox2';
import { axiosTokenInstance } from 'src/utils/axiosInstance.utils';
import { useFormik } from 'formik';
import StyledSnackbar from 'src/components/StyledComponents/StyledSnackBar';
import { surchargeInitialValues } from 'src/utils/initialValues.utils';
import { apiUrls } from 'src/utils/properties.utils';
import { surchargeValidationSchema } from 'src/utils/validationScheme.utils';
import SurchargesGrid from 'src/components/Grids/SurchargesGrid';
import TextArea from 'src/components/InputFields/TextArea';
import { getApiErrorMessage } from 'src/utils/errorHandler';
import SearchBar from 'src/components/InputFields/Searchbar';
import {
  PrimaryActionButton,
  ButtonIcon,
  OverflowContainer,
} from 'src/components/StyledComponents/StyledPageComponents';
const SurchargesManagement: FC = () => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [surchargeAdded, setSurchargeAdded] = useState(false);
  const { showSnackbar } = StyledSnackbar();
  const [searchTerm, setSearchTerm] = useState('');

  const formik = useFormik({
    initialValues: surchargeInitialValues,
    validationSchema: surchargeValidationSchema,
    onSubmit: (values) => handleSubmit(values),
  });

  const handleSubmit = async (values: any) => {
    setLoading(true);
    const percentageValue = values.percentage === '' ? null : values.percentage;
    const defaultValueValue =
      values.defaultValue === '' ? null : values.defaultValue;

    try {
      const addSurcharge = await axiosTokenInstance.post(
        apiUrls.ADD_SURCHARGE,
        {
          name: values.name,
          description: values.description,
          percentage: percentageValue,
          defaultValue: defaultValueValue,
        }
      );
      showSnackbar(addSurcharge.data.message, 'success');
      setSurchargeAdded((prev) => !prev);
      handleClose();
    } catch (e) {
      const errorMessage = await getApiErrorMessage(e);
      showSnackbar(errorMessage, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    formik.resetForm();
    setOpen(false);
  };

  const handleSearchChange = (newQuery: string) => {
    setSearchTerm(newQuery);
  };

  const search = (
    <SearchBar
      id="search"
      value={searchTerm}
      onChange={handleSearchChange}
      placeholder="Search surcharges by name"
    />
  );

  const button = (
    <PrimaryActionButton
      className="btn-primary"
      width="180px"
      onClick={handleClickOpen}
    >
      <ButtonIcon component="i" className="bx bx-plus 1" />
      New Surcharge
    </PrimaryActionButton>
  );

  return (
    <MainLayout
      title="Surcharges Management"
      searchBar={search}
      button={button}
    >
      <SurchargesGrid state={surchargeAdded} searchTerm={searchTerm} />
      <Box display="flex">
        <OverflowContainer display="flex" flexDirection="column">
          <CustomDialog
            height="700px"
            open={open}
            handleClose={handleClose}
            title="Add New Surcharge"
            subtitle="Fill in the details below to add a new surcharge to the system."
            onSubmit={formik.handleSubmit}
            smScreen={smScreen}
            buttonDisabled={loading}
          >
            <TextField
              width="480px"
              id="name"
              label="Surcharge Name"
              formikProps={formik}
            />

            <TextArea
              id="description"
              label="Description"
              formikProps={formik}
            />

            <TextField
              width="480px"
              id="percentage"
              label="Percentage"
              formikProps={formik}
            />
            <TextField
              width="480px"
              id="defaultValue"
              label="Default Value"
              formikProps={formik}
            />
          </CustomDialog>
        </OverflowContainer>
      </Box>
    </MainLayout>
  );
};

export default SurchargesManagement;
